<div class="footer">
  <div class="left">
    <div class="label">
      Total (before taxes)
    </div>
    <div class="total">
      <ng-container *ngIf="(currency | async) as c">
        {{ total | currency: c.code }}
      </ng-container>
    </div>
    <!-- <div>
      credits
    </div> -->
  </div>
  <button
    class="btn btn-theme btn-large select-rooms"
    [disabled]="!total || isLoading"
    (click)="reserve.emit()">
    <span *ngIf="!isLoading">Reserve</span>
    <span *ngIf="isLoading" class="loading-spinner">Loading...</span>
  </button>
</div>
